var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/ClassifiersTree/createTreeModel.ts";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import { combine, createDomain } from 'effector';
import { isNotEmpty } from '@gmini/utils';
import { treeSort } from "../../../helpers";
import * as n from "./../../../Services/UserClassifierRepoService/Node";
import { getChildren } from "./../../../Services/UserClassifierRepoService/UserClassifierRepoService";
var domain = createDomain({
  name: "domain",
  sid: "8ahg2c"
});
export var reset = domain.event('reset', {
  name: "reset",
  sid: "xpk4f6"
}); // Сделать конструктор переиспользуемым другими сервисами

export function createUserClassifierRepoTreeModel(userClassifierRepoService, projectUrn$) {
  var repo$ = combine({
    ɔ: [{
      nodes: userClassifierRepoService.nodes$,
      projectUrn: projectUrn$
    }, function (_ref) {
      var nodes = _ref.nodes,
          projectUrn = _ref.projectUrn;

      if (!projectUrn) {
        return null;
      }

      var key = n.UserClassifierRepoNode.getKey({
        id: projectUrn
      });
      return n.UserClassifierRepoNode.getByKey(nodes, key);
    }],
    config: {
      name: "repo$",
      sid: "gin8xz"
    }
  });
  var root$ = combine({
    ɔ: [{
      nodes: userClassifierRepoService.nodes$,
      relations: userClassifierRepoService.relations$,
      repo: repo$
    }, function (_ref2) {
      var nodes = _ref2.nodes,
          relations = _ref2.relations,
          repo = _ref2.repo;
      return repo ? getChildren(nodes, relations, repo) : [];
    }],
    config: {
      name: "root$",
      sid: "-nju9zl"
    }
  });
  var tree$ = combine({
    ɔ: [{
      root: root$,
      nodes: userClassifierRepoService.nodes$,
      relations: userClassifierRepoService.relations$
    }, function (_ref3) {
      var root = _ref3.root,
          nodes = _ref3.nodes,
          relations = _ref3.relations;

      function createNode(_ref4) {
        var node = _ref4.node,
            path = _ref4.path;

        var recursive = function recursive(_ref5) {
          var id = _ref5.id,
              type = _ref5.type;
          var node = n.Node.getByRef(nodes, {
            id: id,
            type: type
          });

          if (!node) {
            return null;
          }

          switch (node.type) {
            case 'UserClassifierRepoFolderNode':
              {
                var children = getChildren(nodes, relations, node);
                return {
                  id: id,
                  type: node.type,
                  title: node.name,
                  children: children.map(recursive).filter(isNotEmpty),
                  total: node.total,
                  offset: node.offset
                };
              }

            case 'UserClassifierNode':
              {
                var _children = getChildren(nodes, relations, node);

                return {
                  id: id,
                  type: node.type,
                  title: node.name,
                  version: node.version,
                  children: _children.map(recursive).filter(isNotEmpty)
                };
              }

            case 'AssemblyClassifierNode':
              {
                var _children2 = getChildren(nodes, relations, node);

                return {
                  id: id,
                  type: node.type,
                  title: node.name,
                  version: node.version,
                  children: _children2.map(recursive).filter(isNotEmpty),
                  status: node.status
                };
              }

            default:
              return null;
          }
        };

        return recursive(node);
      }

      var tree = root.map(function (node) {
        return createNode({
          node: node,
          path: 1
        });
      }).filter(isNotEmpty);
      return treeSort({
        data: tree,
        itemKey: 'type',
        priorityItemKeyValues: ['UserClassifierRepoFolderNode']
      });
    }],
    config: {
      name: "tree$",
      sid: "f4pxx0"
    }
  });
  return tree$;
}